export const tsmtPitchTherapists = {
  hero: {
    eyebrow: "Bespire × TSMT®",
    title: "Adjunk a TSMT® terapeutáknak egy AI-asszisztenst, ami tényleg leveszi a vállukról a terhet.",
    subtitle:
      "Weboldal, időpontfoglalás, marketing, számlázás, emlékeztetők — egy chatben, magyarul. Olcsóbban, mint külön szoftverekkel, és gyorsabban, mint bármely ügynökséggel.",
    tags: ["Időpontfoglaló", "Kampánymenedzsment", "Weboldal", "AI asszisztens"],
  },
  pain: {
    title: "A terapeuta legnagyobb fájdalompontjai ",
    subtitle: "Ezt halljuk minden TSMT® terapeutától, akivel beszéltünk.",
    items: [
      { title: "Időpontfoglalás", description: "Telefonon, üzenetben, naptárban — három helyen vezetve, mégis átcsúsznak dolgok." },
      { title: "Kampánymenedzsment", description: "Hirdetni kellene, posztolni kellene, de mikor? És miről? És hogyan mérje?" },
      { title: "Számlázás és fizetés", description: "Külön szoftver, külön belépés, kézi egyeztetés, késett befizetések." },
      { title: "Emlékeztetők", description: "Lemondott időpontok, üres helyek, elfelejtett kontroll — mindenki veszít." },
      { title: "Célzott üzenetek", description: "Egy szülő-csoportnak külön infó, egy másiknak más — de nincs idő külön kiküldeni." },
      { title: "Munkatársak", description: "Asszisztenst nem tud fizetni, AI-t nem ért rá tanulni. Egyedül marad." },
    ],
  },
  story: {
    eyebrow: "Miért vagyunk itt",
    title: "Az elejétől fogva terapeutákkal együtt építjük.",
    paragraphs: [
      "Nem véletlenül kezdtük itt. Személyes érintettség van mögötte — a gyerekünket vittük és visszük TSMT® terapeutához, így első kézből látjuk, mit jelent a heti rohanás, a 10 perces ablakok és a hétvégi adminisztráció a terapeuta oldaláról.",
      "A célunk egyértelmű: az AI, ami eddig csak a nagy cégeké volt, álljon rendelkezésre az egyéni és kis KKV szolgáltatóknak is. Segítse az értékesítésüket és a mindennapjaikat, hogy ők minél sikeresebbek legyenek.",
      "A TSMT® terapeuták a tankönyvi ICP-nk: szakmailag erősek, idejük nincs, és az értékük nagy részét ma adminisztráció eszi fel.",
    ],
  },
  evolution: {
    title: "Három lépcsőben váltunk ki egy egész back office-t.",
    subtitle: "Ugyanaz a chat, egyre több feladatot vesz át. Olcsóbb és hatékonyabb, mint külön eszközökkel és külön emberekkel.",
    steps: [
      {
        step: "01",
        title: "Weboldal-építő szolgáltató kiváltása",
        description: "A terapeuta elmondja chatben, mit csinál — és kap egy kész, foglalható, fizetőképes weboldalt. Nincs Wix, nincs fejlesztő, nincs hónapokig tartó projekt.",
      },
      {
        step: "02",
        title: "Marketinges kiváltása",
        description: "Az AI megírja a posztokat, ütemezi őket, létrehozza a kampányokat, és méri, mi működik. A terapeuta jóváhagy — nem tartalmat gyárt.",
      },
      {
        step: "03",
        title: "Személyi asszisztens",
        description: "Időpont-egyeztetés, emlékeztetők, számlázás, üzenetek, csapatkoordináció — mindez chatben, természetes nyelven. Egy hely, egy felület.",
      },
    ],
    footer: "Egy AI asszisztensben, chatelve. Hatékonyabb — és közben olcsóbb, mint a mai különálló eszközök összesen.",
  },
  orsolyaCase: {
    eyebrow: "Hogy nézne ki nálatok",
    title: "Sági-Guth Orsolya — egy konkrét folyamat, lépésről lépésre.",
    subtitle: "Ahogy az AI asszisztens felépíti, beindítja és napi szinten viszi a praxisát.",
    phases: [
      {
        label: "1. Weboldal egy chatben",
        title: "Az AI a TSMT® oldal alapján felépíti Orsolya saját oldalát.",
        bullets: [
          "Bemutatkozás, szakterületek, helyszínek — chatben felteszi a kérdéseket",
          "TSMT® terapeuta jelvény, hivatkozások a hivatalos módszertanra",
          "Saját aldomain vagy egyedi domain — perc alatt",
        ],
      },
      {
        label: "2. Időpontfoglalás",
        title: "A foglalási rendszer beépítve az AI asszisztensbe.",
        bullets: [
          "Helyszínek, időtartamok, szünetek, szabadnapok — chatben beállítva",
          "Online fizetés vagy helyszíni — Orsolya dönti el alkalmanként",
          "Automatikus emlékeztető e-mailben és WhatsApp-on",
        ],
      },
      {
        label: "3. Digitális termékek",
        title: "Otthoni gyakorlatok, kurzusok, csomagok — eladva.",
        bullets: [
          "Videós otthoni gyakorlat-csomag a szülőknek",
          "Online szülő-konzultáció előre fizetve",
          "Workshop-jegyek, sorozat-bérletek",
        ],
      },
      {
        label: "4. A többit eldarálja",
        title: "Számlázás, emlékeztetők, üzenetek — magától.",
        bullets: [
          "Számla automatikusan a fizetés után",
          "Kontroll-emlékeztető a megfelelő szülőnek a megfelelő időben",
          "Csoportos üzenetek célzottan: csak az érintett szülőknek",
        ],
      },
    ],
  },
  dailyFlow: {
    title: "Így néz ki egy hete vele.",
    subtitle: "Minden ugyanabban a chatben. Nem 7 fülön, nem 4 alkalmazásban.",
    items: [
      { title: "Új időpont felvitele", description: "„Tedd be Kovács Lacit szerda 15-re, 45 perces blokk.” — kész." },
      { title: "Időpont meghirdetése", description: "„Nyitottam egy új csütörtök délutáni sávot, posztold ki és értesítsd a várólistást.”" },
      { title: "Napi működés", description: "Reggel a chat összefoglalja: ki jön, ki fizetett, kit kell visszahívni." },
      { title: "Fizetés és számlázás", description: "Online kártya, Apple Pay, helyszíni — a számla automatikusan elmegy a szülőnek." },
      { title: "Emlékeztetők", description: "24 órával előtte, 2 órával előtte — e-mail és WhatsApp, szülő-barátan." },
      { title: "Célzott üzenetek", description: "„Küldd ki a kontrollra szoruló szülőknek, hogy nyitottam januári időpontot.”" },
      { title: "Munkatársak", description: "Ha van asszisztens vagy kolléga, ugyanabban az AI asszisztensben dolgoznak — szerepkörökkel." },
      { title: "Nem csak AI", description: "Emberi support áll mögötte. Magyarul. Ha elakad, valaki felveszi." },
    ],
  },
  integration: {
    eyebrow: "TSMT® integráció",
    title: "A foglalás automatikusan bekerül az LTSZ-be.",
    subtitle: "A lényeg: a Bespire-en leadott foglalás után ugyanaz a flow megy tovább, mint most — csak automatizálva. A terapeutának nem kell külön átvezetnie, időt spórol, és minimalizáljuk a hibázás kockázatát.",
    bullets: [
      "A lefoglalt időpont automatikusan átkerül az LTSZ rendszerbe — nincs kézi átvezetés",
      "Ugyanaz a megszokott LTSZ-flow folytatódik, csak a foglalás eleje van automatizálva",
      "Időmegtakarítás a terapeutának: nem két helyen vezeti ugyanazt",
      "Minimalizált hibázási kockázat — nincs elgépelt név, elfelejtett bevitel, dupla foglalás",
    ],
  },
  partnership: {
    title: "Az együttműködés flywheel-je.",
    subtitle: "Egy lépés mindkettőnknek hoz egy következőt.",
    steps: [
      "Kedvezményes Bespire csomag + ingyenes oktatás a TVTH tagoknak",
      "Bővített terapeuta-profil a TSMT® oldalon, a Bespire weboldalra mutató linkkel",
      "Több értékesítés a terapeutának (foglalás, digitális termék, kurzus)",
      "Nagyobb szoftverhasználat → magasabb LTSZ bevétel",
      "A terapeuta többet kap a TVTH tagságért — láthatóan",
      "Bespire ↔ TSMT® integráció bekerül a rendszerbe",
      "TSMT® ügyfélstream → új terapeuták könnyebben jönnek be, akár a Bespire-en keresztül",
      "Hasznos a nemzetközi terjeszkedésnél is",
    ],
  },
  education: {
    eyebrow: "Oktatás",
    title: "Fogjuk a kezüket — ahogy ti is csináljátok.",
    subtitle: "A TSMT® erőssége a képzés. Mi ugyanezzel a hozzáállással visszük az online oldalt.",
    items: [
      { title: "Online workshopok", description: "Heti / kétheti élő online tréningek a Bespire használatáról, magyarul." },
      { title: "Onboarding kísérés", description: "Az első weboldal és az első foglalás közös felépítése — nem hagyjuk magukra őket." },
      { title: "TVTH tagoknak ingyenes", description: "Az oktatás a TVTH tagság részévé válik — még egy érték a tagdíjért." },
      { title: "Tudásbázis és sablonok", description: "TSMT®-specifikus weboldal-sablonok, posztsablonok, foglalási minták." },
    ],
  },
  pricing: {
    eyebrow: "Árazás",
    title: "TSMT® terapeutáknak kedvezményes csomag.",
    subtitle: "Két modellt teszünk le az asztalra — együtt választjuk a megfelelőt.",
    plans: [
      {
        name: "Modell A — Sávos kedvezmény",
        highlight: "40% az első évben, 20% a másodikban",
        description: "Hosszú távú kötődés, fokozatosan emelkedő használat. A terapeuta beépül az AI asszisztensbe, mire teljes árazásra vált.",
        bullets: [
          "−40% kedvezmény az első 12 hónapban",
          "−20% kedvezmény a második 12 hónapban",
          "Harmadik évtől standard árazás",
        ],
      },
      {
        name: "Modell B — Egyszeri belépő",
        highlight: "50% az első évben",
        description: "Egyszerűbb üzenet, gyorsabb döntés. Ideális a pilot terapeutáknak.",
        bullets: [
          "−50% kedvezmény az első 12 hónapban",
          "Második évtől standard árazás",
          "Könnyebb kommunikálni a TVTH felé",
        ],
      },
    ],
    footerHighlight: {
      badge: "TVTH tagsági előny",
      title: "Az oktatás mindkét modellben teljesen ingyenes a TVTH tagoknak.",
      description: "Egy nem TVTH tagnak ugyanez az oktatási csomag 50.000 Ft + áfa — a tagoknak ez nulla forint, a tagság részeként jár.",
    },
  },
  nextSteps: {
    eyebrow: "Következő lépések",
    title: "Gyors pilot, aztán bejelentés a júliusi konferencián.",
    items: [
      {
        step: "01",
        title: "3–5 terapeuta — ti választjátok",
        description: "Olyanok, akikben látjátok a lendületet és van mit megmutatni. Mi minden mellettük állunk.",
      },
      {
        step: "02",
        title: "Gyors pilot teszt",
        description: "Pár hét alatt felépítjük velük az oldalakat, beindítjuk a foglalást, megtanítjuk őket. Mérünk: foglalás, bevétel, megtartás.",
      },
      {
        step: "03",
        title: "Bejelentés — 2026. július 3.",
        description: "Ha a pilot sikeres, a TSMT® konferencián közösen jelentjük be a partnerséget és a TVTH-tagoknak szóló csomagot.",
      },
    ],
  },
  closing: {
    eyebrow: "Ajánlatunk",
    title: "Építsük közösen a TSMT® terapeuták back office-át.",
    lede: "Nem szoftvert adunk el. Egy partnerséget ajánlunk, amiben a TSMT® erősebb lesz, a TVTH tagság értéke látható, a terapeuták heti 10–15 órát nyernek vissza — és közben együtt építünk valamit, ami nemzetközileg is skálázható.",
    askLabel: "Amit kérünk tőletek",
    asks: [
      "3–5 terapeuta kiválasztása a pilothoz — ti tudjátok, kikben van lendület",
      "Egy közös munkasáv a következő hetekre — gyors visszajelzés, gyors döntés",
      "Bejelentés a 2026. július 3-i TSMT® konferencián, ha a pilot sikeres",
    ],
    giveLabel: "Amit a TSMT® kap cserébe",
    gives: [
      "Bespire ↔ LTSZ integráció — a foglalás automatikusan bekerül a rendszerbe",
      "Kedvezményes csomag + ingyenes oktatás a TVTH tagoknak — kézzelfogható tagsági érték",
      "Magasabb LTSZ használat, láthatóbb TSMT® brand, új terapeuta-stream a Bespire-en keresztül",
    ],
    cta: {
      label: "Következő lépés",
      description: "Egy 30 perces beszélgetés, amin közösen kiválasztjuk a pilot terapeutákat és letesszük a júliusig vezető ütemtervet.",
      buttonLabel: "Időpontot foglalunk",
      contact: "zoltan@bespire.io",
    },
    signoff: "Köszönjük, hogy meghallgattatok. Innen ti döntötök — mi készen állunk.",
  },
};
